import { pushToDataLayer } from '@jbhi-fi/utils/src/ga4Tracking/datalayer';

type WalletClickTrackingProps = {
  walletType: string;
  cardType: 'coupon' | 'member card';
  location: 'modal' | 'header';
};

export const ga4WalletClickTracking = ({ walletType, cardType, location }: WalletClickTrackingProps) => {
  pushToDataLayer({
    event: 'click_wallet_cta',
    type: cardType,
    context: walletType,
    location,
  });
};
